const Aggression = require("../../entities/Aggression")
const {Age}  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class Infiltrate extends Aggression {
    constructor() {
        super(
            Age.Age2,
            AggessionNames.Infiltrate,
            2,
            "Remove your rival's leader or incomplete wonder from play. You score 3 culture per level of the discarded card.",
            {
                //effect
            }
        )
    }
}

module.exports = Infiltrate;